import { $color_grey_9, $color_grey_7 } from '../pebbleGlobalToken/color.js';
import { $font_size_4 } from '../pebbleGlobalToken/font.js';
import { $spacing_m1 } from '../pebbleGlobalToken/spacing.js';

/**
 * 通知提醒框-控制标题字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $notification_color_text_heading = $color_grey_9;

/**
 * 通知提醒框-最深的文本色。为了符合W3C标准，默认的文本颜色使用了该色，同时这个颜色也是最深的中性色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $notification_color_text = $color_grey_7;

/**
 * 通知提醒框-控制内容元素水平内间距，适用于大屏幕设备。
 * @description enDesc: -
 * @description type: Space
 * @description value: $spacing-m1
 */
var $notification_padding_content_horizontal_lg = $spacing_m1;

/**
 * 通知提醒框-控制元素的中等内间距。
 * @description enDesc: -
 * @description type: Space
 * @description value: $spacing-m1
 */
var $notification_padding_md = $spacing_m1;

/**
 * 通知提醒框-大号字体大小
 * @description enDesc: -
 * @description type: Space
 * @description value: $font-size-4
 */
var $notification_font_size_lg = $font_size_4;

/**
 * 通知提醒框-大型文本行高
 * @description enDesc: -
 * @description type: Space
 * @description value: 0.8888888888888888
 */
var $notification_line_height_lg = 0.8888888888888888;

/**
 * 通知提醒框-控制元素的大内间距。
 * @description enDesc: -
 * @description type: Space
 * @description value: $spacing-m1
 */
var $notification_padding_lg = $spacing_m1;

export { $notification_color_text, $notification_color_text_heading, $notification_font_size_lg, $notification_line_height_lg, $notification_padding_content_horizontal_lg, $notification_padding_lg, $notification_padding_md };
